// extracted by mini-css-extract-plugin
module.exports = {"container":"LearnMore_container__1fCLu","content":"LearnMore_content__19oc-","text":"LearnMore_text__3obS-","btn":"LearnMore_btn__2piJL","icon":"LearnMore_icon__1DWOd"};